import { getDataFromScript } from "../utils/helpers";

export default class Page {
  constructor() {
    this.form = document.getElementById('page_update');
    if (this.form) {
      const self = this;
      this.validator = window.solodev.formValidators[this.form.id];
      this.form.querySelector('#builder-frame').addEventListener("load", function() {
        // This is callback called by header button.
        window.solodev.submitForm = () => self.onSavePage();
      });
    }

    this.pageSearchBar = document.getElementById('page-search-bar');
    this.pagesTable = document.getElementById('grid_pages');
    if (this.pageSearchBar && this.pagesTable) {
      this.pages = getDataFromScript('page-table-data');
      this.rows = this.pagesTable.querySelectorAll('tbody tr');
      this.searchInput = this.pageSearchBar.querySelector('#search-input');
      this.sitePicker = this.pageSearchBar.querySelector('select[name=site]');
      this.typePicker = this.pageSearchBar.querySelector('select[name=type]');

      this.initSearch()
    }
  }

  onSavePage() {
    const button = document.getElementById('sd-save-btn');

    if (button.disabled) {
      return;
    }

    const content = this.getDesignerContent();
    const contentInput = this.form.querySelector('#page_update_content')
    contentInput.value = content

    button.disabled = true;
    const buttonLabel = button.querySelector('.sd-btn__label');
    buttonLabel.innerText = 'Saving';

    $.ajax({
      type: 'POST',
      url: window.location.pathname,
      data: $(this.form).serialize(),
      success: function(data) {
        button.disabled = false;
        buttonLabel.innerText = 'Save';
        $.toast({
          heading: 'Save Success',
          text: 'Your page has been saved successfully',
          showHideTransition: 'slide',
          icon: 'success',
          hideAfter: 10000,
        });
      },
      error: function() {
        button.disabled = false;
        buttonLabel.innerText = 'Save';
        $.toast({
          heading: 'Error',
          text: 'Unable to save your page, please try again later',
          icon: 'error',
          hideAfter: 10000
        });
      }
    });
  }

  getDesignerContent() {
    const formDesigner = window.designer;
    let bodyContent = formDesigner.getRawContent();
    const val = formDesigner.replaceTag(formDesigner.minify(bodyContent));
    const el = $("<div></div>").html(val);
    formDesigner.prettifyCode(el);
    bodyContent = formDesigner.undoTag(el.html());
    bodyContent = bodyContent.replace(/&quot;/gi, '\\"');

    return `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <link type="text/css" rel="stylesheet" href="https://www.solodev.com/___/ocoa-designer/vendor/fontawesome/css/all.css">
          <script type="text/javascript" id="jquery" src="http://www.solodev.com/___/ocoa-designer/vendor/jquery/jquery.min.js"></script>
          <script type="text/javascript" src="http://www.solodev.com/___/ocoa-designer/vendor/bootstrap/bootstrap.bundle.min.js"></script>
          <link type="text/css" rel="stylesheet" id="bootstrap_theming" href="http://www.solodev.com/___/ocoa-designer/themes/default/bootstrap.min.css">
        </head>
        <body>
          ${ bodyContent }
        </body>
      </html>
    `;
  }

  initSearch() {
    this.rows.forEach(( tr, key ) => {
      if (!tr.classList.contains('no-data-row')) {
        tr.setAttribute('data-page-id', this.pages[key].id);
      }
    });

    this.searchInput.addEventListener('keyup', this.filterDataTable.bind(this));
    $(this.sitePicker).chosen().change(this.filterDataTable.bind(this));
    $(this.typePicker).chosen().change(this.filterDataTable.bind(this));
  }

  filterBySite(pages, value) {
    return pages.filter( p => p.site_id === value || !value);
  }

  filterByType(pages, value) {
    return pages.filter( p => p.site_type === value || !value);
  }

  filterByName = (pages, value) => pages.filter( p => {
    const name = p.name.toUpperCase();
    const filter = value.toUpperCase();

    return name.indexOf( filter ) > -1 || !value
  });

  filterDataTable() {
    let pagesFiltered = this.pages;
    pagesFiltered = this.filterBySite(pagesFiltered, this.sitePicker.value);
    pagesFiltered = this.filterByType(pagesFiltered, this.typePicker.value);
    pagesFiltered = this.filterByName(pagesFiltered, this.searchInput.value);

    const pagesIdsToShow = pagesFiltered.map( c => c.id );

    this.rows.forEach(( tr ) => {
      if (tr.hasAttribute('data-page-id') && pagesIdsToShow.indexOf(tr.getAttribute('data-page-id')) === -1) {
        tr.classList.add('d-none');
      } else {
        tr.classList.remove('d-none');
      }
    });
  }
}
